







import { Component, Vue } from "vue-property-decorator";

@Component
export default class OverflowTooltip extends Vue {
  isMounted = false;

  get slotContent(): string {
    if (this.$slots.default === undefined) return "";
    const content = this.$slots.default[0].text;
    return content ? content : "";
  }

  get overflow(): boolean {
    if (!this.isMounted) return false;

    const div = this.$el.getElementsByClassName(
      "overflow-div"
    )[0] as HTMLDivElement;

    return div.offsetWidth < div.scrollWidth;
  }

  mounted(): void {
    this.isMounted = true;
  }
}
